import {message} from "antd";

export const ClipboardService = () => {
  return {
    queryPermission() {
      navigator.permissions.query({ name: 'clipboard-write' })
        .then((status) => console.info('[clipboard service]: permission query status: ', status))
        .catch((e) => console.error('[clipboard service]: permission query error: ', e))
    },
    copy(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          console.log('[clipboard service]: text copied to clipboard')
          message.success('Texto copiado com sucesso!')
        })
        .catch(e => console.error('[clipboard service]: failed to copy', e));
    }
  }
}
